(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const faqs = document.querySelectorAll(".faq-question");

    faqs.forEach(faq => {
        faq.addEventListener("click", function () {
            this.parentElement.classList.toggle("active");
        });
    });
});

  } catch(e) { console.error(e); }
})();
})();
